'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

var Module2App1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module2,
    app: state.moduleData.data.module2.app1
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2App1, _Component);

  function Module2App1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2App1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2App1.__proto__ || (0, _getPrototypeOf2.default)(Module2App1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 2,
      appId: 1,
      title: 'Recap',
      isCompleted: _this.props.app.isCompleted || false,
      didTryOfferVege: _this.props.app.didTryOfferVege || ''
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      if (event.target.value === YES) {
        obj[str] = YES;
      } else if (event.target.value === NO) {
        obj[str] = NO;
      } else {
        obj[str] = event.target.value;
      }
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * User types in something for what was
   * involved in the diet
   */


  (0, _createClass3.default)(Module2App1, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Last week we asked you to record all occasions when you offered your child vegetables, regardless of whether s/he ate the vegetable. Were you able to try this?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleChange.bind(this, 'didTryOfferVege') },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'didTryOfferVege', value: YES, checked: this.state.didTryOfferVege === YES || this.state.didTryOfferVege == 1 },
              YES
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'didTryOfferVege', value: NO, checked: this.state.didTryOfferVege === NO || this.state.didTryOfferVege == 0 },
              NO
            )
          ),
          (this.state.didTryOfferVege === YES || this.state.didTryOfferVege == 1) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('p', null)
          ),
          (this.state.didTryOfferVege === NO || this.state.didTryOfferVege == 0) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s ok, maybe it is something you could try another time. The important thing is to think about opportunities or times you can provide vegies at most meals and snacks.'
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module2App1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module2App1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/App/App1.js
// module id = 1181
// module chunks = 0